import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';

export function useRequestSubscriptionCheckoutNotification() {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (payload: { organizationId: string; message?: string }) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/transactions/organization/${payload.organizationId}/subscription-checkout-cart/request-checkout`;
      return sendJSONRequest({
        url,
        method: METHOD.POST,
        body: { message: payload.message },
        token: token ?? '',
      }) as Promise<{ sent: number }>;
    },
  });
}
